<script setup lang="ts">
import { usePlayerFlagsStore } from '@/stores/playerFlagsStore.ts'
import ActionButton from '@/components/Elements/Buttons/ActionButton.vue'
import Alert from '@/components/Elements/Alerts/Alert.vue'
import TutorialFrame from '@/components/Interface/Modal/Modals/Tutorial/TutorialFrame.vue'
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { handleNext, getPreviousStepId } from '../tutorialSteps'
import GenericIcon from '@/components/Elements/Images/Icons/GenericIcon.vue'

const playerFlagsStore = usePlayerFlagsStore()
const route = useRoute()
const router = useRouter()

const handleNextStep = async () => {
  await handleNext('tutorial_military_ships')
}

const isOnCommandSection = computed(() => {
  return route.path.startsWith('/command/ships')
})

const goToCommand = () => {
  router.push('/command/ships')
}

</script>

<template>
  <TutorialFrame
    video-url="https://cdn.ferion.com/videos/advisors/temperate/military.webm"
  >
    <template #text>
      <p class="pb-2">
        Let's examine the current ships screen.
      </p>
      <p class="pb-2 hidden md:flex">
        Your screen will be split into 2 sections, the ships list and the ship detail page. Clicking on a ship's name in the list will open it in the detail page.
      </p>
      <p class="pb-2 md:hidden">
        Here you can find your ships, clicking on a ship's name will open the ship detail page.
      </p>
      <p class="pb-3">
        Each ship has a number of stats:
      </p>
      <div class="grid grid-cols-2 gap-2 pb-3">
        <div class="flex items-center">
          <GenericIcon type="attack_against_ships" class="mr-1"/> Attack vs Ships
        </div>
        <div class="flex items-center">
          <GenericIcon type="attack_against_planets" class="mr-1"/> Attack vs Planets
        </div>
        <div class="flex items-center">
          <GenericIcon type="shields" class="mr-1"/> Shields
        </div>
        <div class="flex items-center">
          <GenericIcon type="max_speed" class="mr-1"/> Max Speed
        </div>
        <div class="flex items-center">
          <GenericIcon type="scanning_range" class="mr-1"/> Scanning Range
        </div>
        <div class="flex items-center">
          <GenericIcon type="repair" class="mr-1"/> Repair
        </div>
      </div>
      <p class="pb-2">
        Below the ships stats you can find the current action chain that is set for the ship. By clicking on the <GenericIcon type="cog"/> icon you can give new orders to a ship. This will automatically redirect you to the map screen where you can set targets visually.
      </p>
    </template>

    <template #alerts>

    </template>

    <template #buttons>
      <ActionButton v-if="!isOnCommandSection" @click="goToCommand" class="mr-2">
        Go to Command
      </ActionButton>
      <ActionButton @click="handleNextStep">
        Continue
      </ActionButton>
    </template>
  </TutorialFrame>
</template>

<style scoped lang="scss"></style>